import React, { useEffect, useState, useRef } from 'react'
import cx from 'classnames'
import { Link } from 'gatsby'
import vsbl from 'vsbl'
import { useEmblaCarousel } from 'embla-carousel/react'

import BlockContent from 'src/components/global/BlockContent'

import { Serializer } from 'src/utils/serializer'
import { Image } from 'src/components/image'
import { handleSlug } from 'src/utils/utils'

import { Arrow } from 'src/components/svgs'

export interface CarouselProps {
  data: {
    text: any[]
  }
}

export const Carousel = ({ data }: CarouselProps) => {
  const { text, backgroundColor, spacing, items } = data

  const [slide, setSlide] = useState(1)

  const [EmblaCarouselReact, embla] = useEmblaCarousel({
    loop: false,
    containScroll: true,
    align: 'start',
  })

  const dom = useRef()
  const [className, setClass] = useState('')
  useEffect(() => {
    const { current } = dom
    const vs = vsbl(current)(() => {
      setClass('is-visible')
    })
    vs.update()
  }, [0])

  useEffect(() => {
    if (embla) {
      embla.on('select', () => {
        setSlide(embla.selectedScrollSnap() + 1)
      })
    }
  }, [embla])

  return (
    <div
      ref={dom}
      className={cx(backgroundColor, className, spacing, {
        cw: backgroundColor === 'bcb',
      })}
    >
      <div className="container--l animate opacity slide-up d2 carousel__header outer mxa py2 p1 al x">
        <BlockContent blocks={text} serializers={Serializer} />
      </div>
      {items && items.length > 1 && (
        <div className="container--l x animate slide-up opacity d2 outer mxa py1 p1 al carousel__wrapper">
          <EmblaCarouselReact>
            <div className="f x aist">
              {items?.map((item, i) => {
                if (item._type === 'service') {
                  return (
                    <div key={i} className="carousel__card rel x">
                      <div className="carousel__card-inner x y bcw cb">
                        <Link
                          style={{ color: 'transparent' }}
                          aria-label="carousel card"
                          className="abs x y top left"
                          to={handleSlug(
                            item._type,
                            item.content.main.slug.current
                          )}
                        >
                          navigate to {item.content.main.title}
                        </Link>
                        <div className="carousel__card-image rel x">
                          <Image
                            imageId={item.content.main.image.asset._id}
                            alt="carousel image"
                          />
                        </div>
                        <div className="p1 carousel__card-text">
                          <h3 className="mt0 mb0">{item.content.main.title}</h3>
                          <p>{item.content.main.shortDescription}</p>
                          <Link
                            className="bold rel z1 underline"
                            to={handleSlug(
                              item._type,
                              item.content.main.slug.current
                            )}
                          >
                            Learn more
                          </Link>
                        </div>
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <div key={i} className="carousel__card x">
                      <div className="carousel__card-inner x y bcw cb">
                        <div className="carousel__card-image rel x">
                          {/* <Image imageId={item.image.asset._id} /> */}
                        </div>
                        <div className="p1 carousel__card-text">
                          {/* <BlockContent blocks={item.text} serializers={Serializer} /> */}
                        </div>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
            <div
              className={cx('my1 py1 f jcs aic', {
                cw: backgroundColor === 'bcb',
              })}
            >
              <button
                aria-label="carousel arrow"
                className={cx('no-style cursor carousel__arrow', {
                  cw: backgroundColor === 'bcb',
                })}
                onClick={() => embla.scrollPrev()}
              >
                <Arrow />
              </button>
              <div className="m1 carousel__dots f jcc aic">
                {items?.map((item, i) => (
                  <span
                    onClick={() => embla.scrollTo(i)}
                    key={i}
                    className={cx('dot block', {
                      'is-active': slide - 1 === i,
                    })}
                  />
                ))}
              </div>
              <button
                aria-label="carousel arrow"
                className={cx('no-style cursor carousel__arrow arrow__rotate', {
                  cw: backgroundColor === 'bcb',
                })}
                onClick={() => embla.scrollNext()}
              >
                <Arrow />
              </button>
            </div>
          </EmblaCarouselReact>
        </div>
      )}
    </div>
  )
}

export default Carousel
